import apiConfig from "./apiConfig";

export const certificateDetails = (_id) => {
    console.log('API CALL')
    return apiConfig.get(`/verify-certificate/details/${_id}`);
}

export const searchUSN = (_data) => {
    return apiConfig.get(`/verify-certificate/search?USN=${_data}`)
}